import installationInstructions from './installationInstructions';

const bulbCategoryContent = {
  installationInstructions
}

export { bulbCategoryContent };
